import {
  combineReducers
} from 'redux-immutable';
import {
  reducer as HomeReducer
} from 'page/home/store';
import {
  reducer as CourseReducer
} from 'page/course/store';
import {
  reducer as CourseExperReducer
} from 'page/course_experiment/store';
import {
  reducer as CourseProjectReducer
} from 'page/course_project/store';
import {
  reducer as CourseLiveReducer
} from 'page/course_live/store';
import {
  reducer as LabRoomReducer
} from 'page/labroom/store';
import {
  reducer as LabRoomExperReducer
} from 'page/labroom_experiment/store';
import {
  reducer as LabRoomVideoReducer
} from 'page/labroom_video/store';
import {
  reducer as PersonalReducer
} from 'page/personal/store';
import {
  reducer as CourseLiveInfoReducer
} from 'page/course_live_info/store';
import {
  reducer as CourseExperInfoReducer
} from 'page/course_experiment_info/store';
export const reducer = combineReducers({
 home:HomeReducer,
 course:CourseReducer,
 courseproject:CourseProjectReducer,
 courselive:CourseLiveReducer,
 courseliveinfo:CourseLiveInfoReducer,
 courseexper:CourseExperReducer,
 courseexperinfo:CourseExperInfoReducer,
 labroom:LabRoomReducer,
 labroomexper:LabRoomExperReducer,
 labroomvideo:LabRoomVideoReducer,
 personal:PersonalReducer
});


export default reducer;